import { useEffect } from 'react';
import hljs from 'highlight.js';
import { initializePanelExpand } from './panelExpand.js';
import { initializeScrollbars, destroyScrollbars } from './scrollBar.js';
import { initializeScrollSpy } from './scrollSpy.js';
import { initializeScrollTo } from './scrollTo.js';
import { initializeTabOverflow } from './tabOverflow.js';
import { initializeToast } from './toast.js';

function decodeHtmlEntities(value) {
	const textarea = document.createElement('textarea');
	textarea.innerHTML = value;
	return textarea.value;
}

function useTemplateInteractions(rootRef) {
	useEffect(() => {
		const root = rootRef.current;
		if (!root) return undefined;

		const cleanupFunctions = [
			initializeScrollTo(root),
			initializeToast(root),
			initializePanelExpand(root),
			initializeTabOverflow(root),
			initializeScrollSpy(root)
		];
		const scrollbars = initializeScrollbars(root);
		let active = true;
		Array.from(root.querySelectorAll('code[data-url]')).forEach(async (element) => {
			try {
				const response = await fetch(element.getAttribute('data-url'));
				if (!response.ok || !active) return;
				element.textContent = decodeHtmlEntities(await response.text());
				hljs.highlightElement(element);
			} catch (error) {
				if (active) element.textContent = 'Example source is unavailable.';
			}
		});

		return () => {
			active = false;
			cleanupFunctions.reverse().forEach((cleanup) => cleanup());
			destroyScrollbars(scrollbars);
		};
	}, [rootRef]);
}

export default useTemplateInteractions;
